export const iconFontAwesomeAstronomySatelliteDish = (
	<i className="fa-solid fa-satellite-dish"></i>
);
